import { useEffect, useState } from "react";

import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";

import { cn } from "@/shared-web.ui/util.cn";

const MobileSwitch = () => {
  const { theme, setTheme } = useTheme();

  // without these mounted setting,
  // component will cause `Hydration failed because the initial UI does not match what was rendered on the server`
  const [mounted, setMounted] = useState(false);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <button
      className={`
        inline-flex items-center justify-start gap-2
      `}
      onClick={toggleTheme}
      type="button"
    >

      {theme === "dark"
        ? (
            <>
              <MoonIcon className="size-5" />
              Dark
            </>
          )
        : (
            <>
              <SunIcon className="size-5" />
              Light
            </>
          )}
    </button>
  );
};

export { MobileSwitch };
